import { createAsyncThunk } from '@reduxjs/toolkit';
import * as featuredItemApi from '../../api/featured-items-api';
import { IFeaturedItem } from '../../models/featurered-item';
import { IResult } from '../../models/result-models';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_FEATURED_ITEMS_SUCCESS = 'LOAD_FEATURED_ITEMS_SUCCESS';
export const LOAD_FEATURED_ITEMS_ERROR = 'LOAD_FEATURED_ITEMS_ERROR';

export const loadFeaturedItemsSuccess = (
    payload: IResult<IFeaturedItem[]>
) => ({
    type: LOAD_FEATURED_ITEMS_SUCCESS,
    payload,
});

export const loadFeaturedItemsError = (payload: IResult<IFeaturedItem[]>) => ({
    type: LOAD_FEATURED_ITEMS_ERROR,
    payload,
});

// Thunks
export const loadFeaturedItems = createAsyncThunk(
    'featuredItems/loadFeaturedItems',
    async (_, thunkAPI) => {
        try {
            thunkAPI.dispatch(beginApiCall());
            const result = await featuredItemApi.getFeaturedItems();
            if (result.ok) {
                thunkAPI.dispatch(loadFeaturedItemsSuccess(result));
            } else {
                thunkAPI.dispatch(
                    apiCallError({
                        name: '',
                        message: 'error getting featured items',
                    })
                );
            }
        } catch (error) {
            thunkAPI.dispatch(apiCallError(error));
            throw error;
        }
    }
);
